import React from 'react'
import styled from 'react-emotion'

import cloudbedsBtn from '../../assets/cloudbeds-app-button-bg.png'

const CloudButton = styled.a`
  cursor: pointer;
  color: white;
  background: #0278bc;
  text-decoration: none;
  margin: 0;
  line-height: 37px;
  width: 185px;
  height: 37px;
  border-radius: 2px;
  font-size: 12.5px;
  text-align: center;

  &:hover {
    background: #006dac;
  }
`

const LearnAboutCloudbedsButton = () => {
  const url = `https://www.cloudbeds.com/?utm_source=whistle&utm_medium=landing&utm_campaign=whistle`
  
  return (
    <CloudButton
      href={url}
      title="Learn More About Cloudbeds"
    >Learn More About Cloudbeds</CloudButton>
  );
}

export default LearnAboutCloudbedsButton


// WEBPACK FOOTER //
// ./src/components/buttons/LearnAboutCloudBedsButton.js